import { ITranslationSchema } from '../type';

const translation: ITranslationSchema = {
  auth: {
    accountVerification: {
      code: {
        sent: "Nous venons d'envoyer un code à {{to}}. Entrez-le ici pour confirmer votre identité!",
        title: 'Vérifier vos messages',
      },
    },
    common: {
      emailLabel: 'Votre email',
      emailPlaceholder: 'Saisissez votre email',
      errors: {
        confirmationCodeMissing: 'Veuillez saisir votre code',
        emailAlreadyExists: 'Un compte avec cet email existe déjà. Veuillez essayer de vous connecter à la place.',
        emailDomainNotAllowed: 'Cette adresse email ne peut pas être utilisée',
        emailInvalid: "Nous n'avons pas pu lire cet email. Vérifiez qu'il ressemble à nom@email.com",
        emailRequired: 'Veuillez saisir votre email',
        invalidCredentials: 'Identifiant ou mot de passe incorrect',
        missingPasswordFields: 'Veuillez remplir les deux champs de mot de passe',
        mobileNumberRequired: 'Veuillez saisir votre numéro de mobile',
        passwordConfirmationMissing: 'Veuillez saisir votre mot de passe à nouveau',
        passwordFormatDescription:
          'Au moins 8 caractères, 1 chiffre, 1 lettre majuscule et 1 caractère spécial (comme ! ou ?).',
        passwordRequired: 'Veuillez saisir votre mot de passe',
        passwordTooShort: 'Le mot de passe est trop court',
        passwordsDoNotMatch: 'Les mots de passe ne correspondent pas. Veuillez vérifier à nouveau',
        phoneNumberCountryCodeRequired:
          "Le numéro de téléphone doit inclure l'indicatif pays (par ex. +33 pour la France)",
        phoneNumberInvalid: 'Veuillez saisir un numéro de téléphone mobile britannique valide',
        phoneNumberRequired: 'Veuillez saisir votre numéro de téléphone',
        resetPasswordFailed: 'Échec de la réinitialisation du mot de passe. Veuillez réessayer.',
        respondentSlotUnavailable:
          "Ce compte ne peut pas être utilisé avec cette invitation. Vérifiez que vous utilisez votre propre adresse e-mail ou numéro de téléphone, et non celui d'une autre personne. Si le problème persiste, contactez {{supportEmail}}.",
        serverError: 'Erreur serveur. Veuillez réessayer plus tard.',
        usernameInvalid: 'TODO',
        usernameRequired: 'TODO',
      },
      mfa: {
        codeDescription: 'Nous avons envoyé un code à votre numéro de téléphone portable enregistré.',
        errors: {
          mfaVerificationFailed:
            "Nous n'avons pas pu vérifier votre code. Veuillez le vérifier et réessayer, ou en demander un nouveau.",
          resendCodeFailed: 'Impossible de renvoyer le code. Veuillez réessayer.',
        },
      },
      mobileLabel: 'Votre mobile',
      mobilePlaceholder: 'Saisissez votre mobile',
      passwordLabel: 'Mot de passe',
      passwordPlaceholder: 'Saisissez votre mot de passe',
      passwordRepeatPlaceholder: 'Répétez le mot de passe',
      repeatPasswordLabel: 'Répéter le mot de passe',
      showPassword: 'afficher',
      usernameLabel: 'Votre email',
      usernamePlaceholder: 'Saisissez votre email',
    },
    confirmForgotPassword: {
      codeLabel: 'Code de vérification',
      description:
        'Si les informations que vous avez fournies sont valides, un code de vérification vous sera envoyé par e-mail ou par SMS. Après réception du code, vous pourrez choisir un nouveau mot de passe pour votre compte.',
      newPasswordLabel: 'Mot de passe',
      repeatPasswordLabel: 'Confirmez votre mot de passe',
      resendCode: {
        didntReceive: "Vous n'avez pas reçu de code ?",
        resendButton: 'Le renvoyer maintenant',
      },
      resetPasswordButton: 'Réinitialiser le mot de passe',
      success: {
        message: 'Réinitialisation du mot de passe réussie.',
      },
      title: 'Mot de passe oublié ?',
    },
    forgotPassword: {
      description:
        "Saisissez l'adresse email associée à votre compte et nous vous enverrons un code pour réinitialiser votre mot de passe.",
      title: 'Mot de passe oublié ?',
    },
    forgotPasswordSuccess: {
      description: 'Utilisez le nouveau mot de passe maintenant pour vous connecter à votre compte',
      returnButton: 'Retour à la connexion',
      title: 'Votre mot de passe a été mis à jour.',
    },
    login: {
      crisisCheck: {
        title: 'Contrôle de sécurité',
        description:
          "Ce service n'est pas conçu pour les situations d'urgence. <br/><br/> Si vous avez besoin d'aide immédiatement ou à tout moment, veuillez appuyer sur le bouton \"Aide urgente\" en haut de la page pour obtenir les coordonnées.",
      },
      forgotPasswordLinkText: 'Mot de passe oublié ?',
      mfa: {
        codeInputLabel: 'Saisissez vos informations ci-dessous pour vous connecter.',
        submit: 'Vérifier et continuer',
        title: 'Vérifiez votre téléphone',
      },
      signInButtonText: 'Se connecter',
      title: 'Connexion',
      welcomeHeader: 'Bienvenue',
    },
    register: {
      agreeTermsAndConditionsText: "J'accepte les Conditions d'utilisation et la Politique de confidentialité.",
      alreadyHaveAccountSubHeader: 'Vous avez déjà un compte? <signInLink/>',
      errors: {
        confirmNotInCrisis:
          "Vous devez accepter que vos réponses ne seront envoyées à l'équipe soignante qu'une fois le questionnaire soumis.",
        confirmTAndC: 'Vous devez accepter les conditions générales.',
        missingRequiredFields: 'Veuillez remplir tous les champs obligatoires.',
        requestFailed: "L'inscription a échoué. Veuillez réessayer.",
        termsNotAccepted: 'Veuillez accepter les conditions générales pour continuer.',
        validationFailed: 'Veuillez vérifier vos informations et réessayer.',
      },
      mainHeader: 'Créez votre compte pour commencer le questionnaire',
      mfa: {
        selfReferralCodeInputLabel: 'Entrez-le ci-dessous',
        codeInputLabel: 'Saisissez vos informations ci-dessous pour créer votre compte.',
      },
      notInCrisisText:
        "Je ne suis pas en situation de crise et je comprends que ce service n'offre pas d'aide urgente. <urgentHelpLink>{{urgentHelp}}</urgentHelpLink> ou le bouton en haut de l'écran",
      notInCrisisUrgentHelpText: 'Pour obtenir une aide urgente, cliquez ici.',
      passwordLess: {
        switchToEmailUsernameLabel: 'Votre email',
        switchToMobileUsernameLabel: 'Votre mobile',
        header: 'Vérifiez votre numéro de téléphone pour démarrer le parrainage',
        subHeader: 'Nous vous enverrons un code de vérification pour confirmer votre identité.',
      },
      referralPortal: {
        mainHeader: 'Créez votre compte',
        submit: "S'inscrire",
      },
      startSurveyButtonText: 'Commencer le questionnaire',
      switchToEmailUsernameLabel: "S'inscrire avec un email",
      switchToMobileUsernameLabel: "'inscrire avec un mobile",
      termsAndPrivacy: {
        agreeText:
          "J'accepte les <termsLink>{{termsOfUse}}</termsLink> et la <privacyLink>{{privacyPolicy}}</privacyLink>.",
        privacyPolicy: 'Politique de confidentialité',
        termsOfUse: "Conditions d'utilisation",
      },
      title: 'Créer un compte',
    },
  },
  common: {
    buttons: {
      back: 'Retour',
      backToMyAccount: 'Mon compte',
      cancel: 'Annuler',
      close: 'Fermer',
      continue: 'Continuer',
      copied: 'Copié',
      copy: 'Copier',
      copyLink: 'Copier le lien',
      edit: 'Modifier',
      goBack: 'Retour',
      hide: 'Masquer',
      home: "Écran d'accueil",
      next: 'Suivant',
      ok: 'OK',
      send: 'Envoyer',
      show: 'Afficher',
      submit: 'Soumettre',
      survey: 'Sondage',
      view: 'Voir',
    },
    errors: {
      cookiesBlocked: {
        title: 'Votre navigateur bloque les cookies',
        subtitle:
          "Ce site utilise des cookies pour vous permettre de rester connecté en toute sécurité. Veuillez autoriser les cookies pour ce site dans les paramètres de votre navigateur, puis rechargez la page. Si vous avez encore besoin d'aide, n'hésitez pas à contacter <linkTag />. Merci.",
      },
      generic:
        "Quelque chose s'est mal passé, veuillez réessayer. Si le problème persiste, veuillez contacter {{supportEmail}}",
      networkError: 'Erreur réseau. Veuillez vérifier votre connexion et réessayer.',
      notFound: 'Page introuvable',
      required: 'Ce champ est obligatoire',
    },
    table: {
      actions: 'Actions',
    },
  },
  date: {
    long: '{{date, datetime(dateStyle:full)}}',
    short: '{{date, datetime}}',
  },
  datetime: {
    long: '{{date, datetime(dateStyle:full; timeStyle:short)}}',
    short: '{{date, datetime(dateStyle:short; timeStyle: short)}}',
  },
  model: {
    common: {
      'created-at': 'Créé le',
      publicId: 'ID public',
      respondentName: 'Nom du répondant',
      respondentType: {
        carer: 'Carer',
        informant1: 'Informant',
        patient: 'Patient',
      },
      respondentTypeLabel: 'Type de répondant',
      serviceUserLink: 'Lien',
      status: 'Statut',
    },
    invite: {
      status: {
        cancelled: 'Annulé',
        completed: 'Terminé',
        expired: 'Expiré',
        pending: 'En attente',
      },
    },
    referralSession: {
      status: {
        cancelled: 'Annulé',
        completed: 'Terminé',
        expired: 'Expiré',
        pending: 'En attente',
      },
    },
    referrals: {
      'completed-at': 'Terminé le',
      'completion-date': "Date d'achèvement",
      name: 'Nom',
      'patient-pi-system-id': 'ID',
      'referral-date': "Date d'orientation",
      service: 'Service',
      status: {
        cancelled: 'Annulé',
        completed: 'Terminé',
        expired: 'Expiré',
        pending: 'En attente',
      },
    },
  },
  navigation: {
    back: 'Retour',
    home: 'Accueil',
  },
  page: {
    about: {
      howItWorks: {
        description:
          'Cette application utilise des questionnaires standardisés pour aider à collecter des informations sur vos symptômes qui seront examinées par un professionnel de santé',
        title: '',
      },
      loadingState: "Récupération des informations de l'application...",
      noData: "Informations de l'application introuvables !",
      softwareInfo: {
        appName: "Nom de l'application",
        appVersion: "Version de l'application",
        manufacturer: 'Fabricant ou mainteneur',
        title: 'Informations logicielles',
      },
      title: 'À propos de cette application',
    },
    account: {
      aboutLink: 'À propos de cette application',
      changePassword: 'Changer le mot de passe',
      changePasswordForm: {
        currentPassword: 'Mot de passe actuel',
        newPassword: 'Nouveau mot de passe',
        passwordRequirements: {
          lowercase: 'Un caractère minuscule',
          minLength: 'Au moins 8 caractères',
          numeric: 'Un caractère numérique',
          symbol: 'Un caractère symbole (! # % & $ @)',
          title: 'Votre mot de passe doit contenir :',
          uppercase: 'Un caractère majuscule',
        },
        repeatPassword: 'Répétez le nouveau mot de passe',
      },
      changePasswordSuccess: {
        button: 'Mon compte',
        title: 'Mot de passe modifié avec succès !',
      },
      loadingState: 'Récupération des détails utilisateur...',
      privacyLink: 'Politique de confidentialité',
      signOut: 'Se déconnecter',
      support: "Si vous avez besoin d'aide concernant les paramètres de votre compte, veuillez contacter <linkTag />.",
      termsLink: "Conditions d'utilisation",
      title: 'Mon compte',
      userNotFound: 'Utilisateur introuvable',
    },
    activityDashboard: {
      accountCreatedCard: {
        title: 'Compte créé',
      },
      cancelledCard: {
        title: 'Annulé',
      },
      completionRateCard: {
        subtext: 'Dans les {{days}} derniers jours',
        title: 'Taux de complétion',
      },
      expiredCard: {
        title: 'Expiré',
      },
      invitesCard: {
        title: 'Orientations',
      },
      referralDateLabel: "Date d'orientation entre",
      reportsCompletedCard: {
        title: 'Rapports Completés',
      },
      title: "Tableau de bord d'activité",
    },
    clinicianHomepage: {
      aiChat: {
        assistant: 'Assistant',
        disclaimer: 'Prototype · données synthétiques · pas pour des décisions cliniques',
        empty: 'Posez une question sur les orientations, les délais de complétion ou les questions répondues.',
        errors: {
          aborted: 'Arrêté.',
          conversationTooLong: 'Cette conversation est trop longue. Commencez une nouvelle conversation.',
          generic: "Une erreur s'est produite. Réessayez.",
          maxTokens: 'La réponse était trop longue et a été coupée.',
          network: 'La connexion a été perdue. Réessayez.',
          rateLimited: 'Trop de questions. Attendez la réponse en cours ou réessayez plus tard.',
          refusal: "L'assistant a refusé de répondre à cette question.",
          timeLimit: 'La réponse a pris trop de temps et a été arrêtée.',
        },
        newConversation: 'Nouvelle conversation',
        placeholder: "ex. Combien d'orientations ont été créées chaque mois cette année ?",
        question: 'Question',
        send: 'Demander',
        sql: {
          copied: 'Copié',
          copy: 'Copier le SQL',
          outcomeError: 'Erreur',
          outcomeRejected: 'Rejeté',
          outcomeTimeout: 'Délai dépassé',
          rowCount: 'Lignes : {{count}}',
          suppressed: 'Masquées (n < 5) : {{count}}',
          title: 'SQL utilisé ({{count}} requêtes)',
          truncated: 'Tronqué',
        },
        stop: 'Arrêter',
        thinking: 'En cours…',
        title: 'Interroger les données (prototype)',
        you: 'Vous',
      },
      disclaimer: {
        text: "Tout accès aux dossiers patients est surveillé. L'accès non autorisé peut entraîner des sanctions disciplinaires ou des poursuites judiciaires.",
      },
      latestActivity: {
        buttonText: "Voir toute l'activité",
        completionRateCard: {
          subtext: 'Dans les {{days}} derniers jours',
          title: 'Taux de complétion',
        },
        invitesCard: {
          subtext: 'Dans les {{days}} derniers jours',
          title: 'Orientations',
        },
        reportsCompletedCard: {
          subtext: 'Dans les {{days}} derniers jours',
          title: 'Rapports Completés',
        },
        title: 'Activité récente',
      },
      latestCompletions: {
        buttonText: 'Voir tous les rapports',
        title: 'Derniers achèvements',
      },
      menu: {
        activityDashboard: "Tableau de bord d'activité",
        aiChat: 'Interroger les données (prototype)',
        clinicalReports: 'Rapports cliniques',
        instructionsForUse: "Instructions d'utilisation",
        referralUploadJobs: "Téléversement groupé d'orientations",
        signOut: 'Se déconnecter',
      },
      title: 'Bon retour',
    },
    healthLibrary: {
      bannerText:
        "🔗 Les liens externes sont en gras et soulignés et s'ouvrent hors de la page. Le bouton «Besoin d'aide urgente» peut ne pas être disponible sur la nouvelle page. Utilisez le bouton «Retour» de votre navigateur ou fermez l'onglet pour revenir à la page précédente.",
      errors: {
        notFound: 'Cet article est introuvable',
      },
      filterTitle: 'Filtrer par sujet',
      otherTopicTitle: 'Autre',
      subtitle:
        'Votre espace pour lire et en apprendre davantage sur la santé mentale et les thématiques de neurodiversité.',
      subtitle2:
        "Ce contenu est une information générale de santé destinée à soutenir votre compréhension. Il n'a pas été personnalisé et ne remplace pas un avis clinique.",
      subtitle3:
        'Si ce que vous lisez soulève des questions ou des inquiétudes, veuillez en parler avec votre équipe soignante.',
      title: 'Bibliothèque de santé',
    },
    home: {
      cardMessage: {
        cancelled: 'Non disponible',
        completed: 'Terminé',
        contactSupport: 'Contactez <supportLink/> pour plus d’informations',
        expired: 'Expiré',
        inProgress: 'Non Commencé',
        notStarted: 'Commencé',
        sent: 'Envoyé',
      },
      checkIns: {
        header: 'Your Check-ins',
        info: 'Here you can find all of your questionnaires',
      },
      greeting: 'Salut',
      healthLibraryCard: {
        badge: 'Nouveau',
        description: "En savoir plus sur les symptômes courants et les mécanismes d'adaptation",
      },
      loadingState: 'Chargement des détails du parrainage',
      noActiveReferral: {
        subtitle:
          "Veuillez utiliser le lien figurant dans votre lettre de recommandation ou retourner au lien d'auto-recommandation pour continuer. <br/><br/> Si vous avez besoin d'aide, contactez-nous à <linkTag/>",
        title: "Nous n'avons trouvé aucune référence active.",
      },
      questionnaires: {
        header: 'Vos questionnaires',
      },
    },
    mfaSetup: {
      phone: {
        alreadyHaveCode: 'Vous avez déjà un code? <enterCodeLink />',
        description:
          'Pour garantir la confidentialité et la sécurité de vos données, nous devrons vous envoyer un code unique sur votre téléphone portable.',
        enterCodeHere: 'Entrez-le ici',
        label: 'Veuillez saisir votre numéro de téléphone portable',
        placeholder: 'Numéro de mobile (ex. +447123456789)',
        submit: 'Envoyer le code',
        title: 'Secure your account',
      },
      code: {
        changeNumber: 'fournissez un autre numéro',
        contactSupport: "Contactez <linkTag /> pour obtenir de l'aide",
        description: 'Nous avons envoyé un code à {{phoneNumber}}',
        helpPrefix: "Vous n'avez pas reçu le message ? <retryLink />",
        helpPrefixWithSecondLink: "Vous n'avez pas reçu le message ?? <retryLink /> ou <secondLink />",
        placeholder: 'Code du message',
        startAgain: 'Start again',
        submit: 'Vérifier',
        title: 'Entrez votre code',
        tryAgain: 'Essayer à nouveau',
        tryAgainIn: 'Réessayer dans {{seconds}} secondes',
      },
    },
    professionalReferral: {
      breadcrumb: {
        createReferralRequest: "Créer une demande d'orientation",
        editReferralRequest: "Modifier la demande d'orientation",
        questionnaire: 'Questionnaire',
      },
      home: {
        availableServices: 'Services disponibles',
        cancelDialog: {
          confirmationLabel: "Saisissez '{{keyword}}' pour confirmer",
          description:
            "Cette action annulera toutes les sessions en attente de cette demande d'orientation, et les invitations en cours seront retirées. Cette action est irréversible.",
          error: "Impossible d'annuler cette demande d'orientation. Elle a peut-être déjà été terminée ou annulée.",
          keyword: 'ANNULER',
          title: "Annuler la demande d'orientation",
        },
        draftReferralRequests: "Brouillons de demandes d'orientation",
        draftsError: "Impossible de charger vos brouillons de demandes d'orientation. Veuillez réessayer plus tard.",
        error: 'Impossible de charger vos orientations soumises. Veuillez réessayer plus tard.',
        invites: {
          delayed:
            "Le traitement prend plus de temps que prévu. Si elle n'apparaît pas rapidement, veuillez contacter l'assistance.",
          none: 'Aucune invitation pour cette orientation',
          phoneNumber: 'Numéro de téléphone',
          preparing: 'Les invitations sont en cours de préparation',
        },
        submittedReferrals: 'Orientations soumises',
        table: {
          cancelReferral: "Annuler la demande d'orientation",
          delayed: 'Retardé',
          expiresAt: "Date d'expiration",
          notProvided: 'Non renseigné',
          organisation: 'Organisation',
          patientName: 'Nom du patient',
          piSystemId: 'Identifiant du patient',
          sending: 'Envoi en cours…',
          service: 'Service',
          status: 'Statut',
          submittedAt: 'Soumis le',
        },
      },
      referralRequest: {
        familyNameLabel: 'Nom de famille',
        givenNameLabel: 'Prénom',
        patientIdLabel: 'Identifiant du patient',
        phoneNumberLabel: 'Numéro de téléphone',
        saveAndContinueButton: 'Enregistrer et continuer',
      },
      submit: {
        title: 'Soumettre la demande de recommandation',
        cautionText:
          "Veuillez noter : les invitations sont envoyées immédiatement. Veuillez vérifier les coordonnées des destinataires et le service sélectionné avant l'envoi.",
        notReadyError:
          "Cette demande d'orientation n'est pas prête à être envoyée. Veuillez revenir en arrière et vérifier ses détails.",
        errors: {
          contactIncomplete:
            "Les coordonnées d'un répondant sont incomplètes. Veuillez renseigner le prénom, le nom de famille et le numéro de téléphone de chaque répondant.",
          missingPatientId: 'Un identifiant de patient est requis.',
          noPhoneNumber: 'Au moins un répondant doit avoir un numéro de téléphone pour pouvoir être invité.',
          patientIncomplete:
            'Certaines informations requises sur le patient sont manquantes. Veuillez revenir en arrière pour les compléter.',
          surveyIncomplete: "Le questionnaire du prescripteur n'a pas été complété.",
        },
      },
      welcome: {
        fallbackText: "Commencez votre parcours d'inscription à l'orientation professionnelle.",
        header: 'Bienvenue',
      },
    },
    questionnaireEnd: {
      header1: "Merci d'avoir soumis votre questionnaire !",
      header2: "Besoin de parler à quelqu'un maintenant ?",
      header3: "Besoin d'un soutien urgent ?",
      paragraph1: "Vos réponses ont été envoyées à l'équipe de soins.",
      paragraph2:
        "Ces services offrent un soutien confidentiel de bénévoles formés. Vous pouvez parler de tout ce qui vous trouble, peu importe la difficulté, et ils ne partageront vos informations que s'ils sont très inquiets pour vous ou pensent que vous êtes en danger immédiat :",
      supportServices:
        '<ul><li>• Appelez 116 123 pour parler aux <samaritanLink/>, ou envoyez un email : jo@samaritans.org pour une réponse dans les 24 heures</li><li>• Envoyez "SHOUT" au 85258 pour contacter la <shoutLink/>, ou envoyez "YM" si vous avez moins de 19 ans</li><li>• Si vous avez moins de 19 ans, vous pouvez aussi appeler le 0800 1111 pour parler à <childlineLink/>. Le numéro n\'apparaîtra pas sur votre facture téléphonique.</li></ul>',
      urgentSupport:
        "<ul><li>• Obtenez de l'aide sur <nhs111Link/> ou appelez le 111 et sélectionnez l'option santé mentale. Alternativement, demandez un rendez-vous urgent avec votre médecin généraliste</li><li>• Appelez le 999 ou allez aux urgences maintenant si :<ul><li>• La vie de quelqu'un est en danger – par exemple, ils se sont gravement blessés ou ont pris une overdose.</li><li>• Vous ne pensez pas pouvoir assurer votre sécurité ou celle de quelqu'un d'autre.</li></ul></li></ul>",
    },
    referralRequestSurvey: {
      errors: {
        notFound: 'Désolé, nous n’avons pas trouvé ce sondage.',
        conflict: 'Ce sondage a été mis à jour ailleurs. Veuillez <refreshLink /> pour voir la dernière version.',
      },
    },
    referralUploadJobs: {
      erroredRows: {
        eprId: 'EPR ID',
        error: 'Erreur',
        name: 'Nom',
        none: 'Aucune ligne en erreur pour ce téléversement',
        rowNumber: 'Ligne',
      },
      errors: {
        duplicateColumns: 'Colonne(s) en double : {{columns}}',
        duplicateReferralRow:
          'Ligne {{rowNumber}} : l’identifiant EPR {{eprId}} et le service {{service}} apparaissent plusieurs fois dans le fichier',
        emptyColumnHeader: 'Le fichier contient un en-tête de colonne vide',
        fieldTooLongRow: 'Ligne {{rowNumber}} : {{columns}} ne doit pas dépasser {{max}} caractères',
        fileNameTooLong: 'Le nom du fichier ne doit pas dépasser {{max}} caractères',
        fileReadError: 'Le fichier n’a pas pu être lu. Veuillez réessayer.',
        fileTooLarge: 'Le fichier est trop volumineux ; la taille maximale est de {{maxSizeMb}} Mo',
        genericFailure: 'Une erreur est survenue lors du téléversement du fichier. Veuillez réessayer.',
        incompleteCarerRow:
          'Ligne {{rowNumber}} : les informations sur le proche aidant sont incomplètes, {{columns}} manquant(es)',
        incompleteInformant1Row:
          "Ligne {{rowNumber}} : les informations sur l'informateur sont incomplètes, {{columns}} manquant(es)",
        incompleteRow: 'La ligne {{rowNumber}} ne contient pas : {{columns}}',
        invalidPhoneNumberRow: 'Ligne {{rowNumber}} : {{columns}} doit être un numéro de mobile valide',
        malformedCsv: 'Impossible de lire le fichier CSV : {{reason}}',
        missingColumns: 'Colonne(s) requise(s) manquante(s) : {{columns}}',
        noDataRows: 'Le fichier ne contient aucune ligne de données',
        tooManyRows: 'Le fichier contient trop de lignes ({{count}}) ; le maximum est de {{max}}',
        unrecognisedColumns: 'Colonne(s) non reconnue(s) : {{columns}}',
        validationFailed:
          'Le fichier n’a pas pu être traité. Veuillez vérifier les colonnes et les données requises, puis réessayer.',
      },
      previousUploads: 'Téléversements précédents',
      services: 'Choisissez un service pour lequel téléverser des orientations',
      table: {
        complete: 'Terminées',
        errored: 'En erreur',
        fileName: 'Nom du fichier',
        pending: 'En attente',
        rowCount: 'Lignes',
        service: 'Service',
        uploadedAt: 'Téléversé le',
        uploadedBy: 'Téléversé par',
      },
      title: "Téléversement groupé d'orientations",
      upload: 'Téléverser',
      uploadSuccessOne: '{{rowCount}} ligne a été téléversée et est en attente de traitement.',
      uploadSuccessOther: '{{rowCount}} lignes ont été téléversées et sont en attente de traitement.',
      uploadSuccessTitle: 'Téléversement terminé',
      uploadTitle: "Téléversement groupé d'orientations : {{serviceDescription}}",
    },
    referrals: {
      invites: {
        none: 'Aucun répondant pour cette orientation',
      },
      report: 'Rapport',
      title: 'Rapports cliniques',
      'view-report': 'Voir le rapport',
    },
    report: {
      errors: {
        InviteExpired: {
          subtitle: "Cela signifie qu'il a été orienté, mais que son invitation a expiré avant d'être terminée.",
          title: "Cet usager n'a pas de rapport beseen ni d'orientation active.",
        },
        InviteNotFound: {
          subtitle:
            "Cela signifie qu'on ne lui a pas demandé de remplir le questionnaire et qu'aucun rapport beseen ne sera disponible.",
          title: "Cet usager n'a pas été orienté vers beseen",
        },
        ReferralCancelled: {
          subtitle:
            "Cela signifie qu'il a été orienté, mais n'a pas rempli le questionnaire, et celui-ci n'est plus disponible.",
          title: "Cet usager n'a pas de rapport beseen ni d'orientation active.",
        },
        ReferralPending: {
          subtitle: "Le questionnaire n'a pas été rempli par l'usager. Le rapport apparaîtra une fois terminé.",
          title: 'Rapport pas encore disponible',
        },
        notFound: 'Rapport non trouvé',
      },
    },
    reportAdmin: {
      errors: {
        noReports: 'Aucun rapport',
        noSurveys: 'Aucun questionnaire',
      },
    },
    smsOptOut: {
      header: 'Êtes-vous sûr de vouloir vous désabonner ?',
      confirmButton: 'Confirmer',
      errors: {
        missingParameters: 'Lien de désabonnement invalide. Veuillez contacter le support.',
        generic: 'Impossible de traiter votre demande. Veuillez réessayer plus tard.',
      },
    },
    smsOptOutSuccess: {
      header: 'Succès ! Vous ne recevrez plus de rappels pour cette orientation.',
    },
    viewReferral: {
      dataSafetyContent:
        'Psyomics collecte et traite les données que vous fournissez de manière sécurisée, sensible et privée. {{organisationName}} recevra vos réponses une fois que vous les aurez soumises et les ajoutera à votre dossier médical pour permettre à votre prestataire de soins de les examiner. Pour en savoir plus sur la façon dont nous traitons vos données et les gardons en sécurité, veuillez consulter notre <0>Politique de confidentialité.</0>',
      dataSafetyTitle: 'Vos données restent en sécurité',
      errors: {
        notFound: "Désolé, nous n'avons pas trouvé cette référence.",
      },
      fillingChoice: 'Le remplir est votre choix',
      fillingHelpNote: 'mais cela nous aide vraiment à vous aider.',
      introText:
        "Ce questionnaire aide l'équipe {{organisationName}} à comprendre vos besoins et à planifier les meilleurs soins pour vous.",
      linkExpired: {
        body: 'Vous ne savez pas comment les contacter ? Écrivez-nous à <linkTag />',
        header: "Ce lien ne fonctionne plus. Veuillez contacter votre équipe soignante si vous avez besoin d'aide.",
      },
      nextButton: 'Suivant',
      questionnaireInProgress: {
        body: "Le nouveau rapport apparaîtra ici une fois terminé, mais vous pouvez consulter les rapports précédents de l'utilisateur du service ici.",
        header: 'Nouveau questionnaire en cours',
      },
      welcomeMessage: 'Bienvenue {{name}},',
      whatToExpect1: 'Prend environ 40 minutes.',
      whatToExpect2: 'Vous pouvez faire une pause à tout moment — votre progression est sauvegardée.',
      whatToExpect3: 'Les questions portent sur vos sentiments, expériences et vie quotidienne.',
      whatToExpectTitle: "À quoi s'attendre",
      whyComplete1: 'Cela peut rendre votre rendez-vous plus utile.',
      whyComplete2: 'Cela peut nous aider à mieux vous comprendre.',
      whyComplete3: 'Cela peut soutenir de meilleures décisions concernant vos soins.',
      whyCompleteTitle: 'Pourquoi le compléter ?',
    },
    viewSurvey: {
      errors: {
        attachmentValidationFailed:
          'Une ou plusieurs pièces jointes n’ont pas pu être vérifiées. Veuillez <refreshLink>actualiser</refreshLink> pour réessayer.',
        conflict:
          'Vous avez effectué des modifications ailleurs, <refreshLink /> cet onglet pour voir la dernière version.',
        notFound: 'Questionnaire non trouvé',
      },
    },
    welcome: {
      title: 'Bienvenue chez beseen',
    },
  },
  report: {
    answerSkipped: 'Sauté',
    blocks: {
      attachments: {
        columnHeaderContentType: 'Type de contenu',
        columnHeaderCreatedAt: 'Téléversé',
        columnHeaderFileName: 'Nom du fichier',
        columnHeaderFileSize: 'Taille du fichier',
        columnHeaderRespondentType: 'Type de répondant',
      },
      exportPDFButton: {
        buttonText: 'Exporter en PDF',
      },
      measureBreakdown: {
        appendixTitle: 'Annexe de calcul du score',
        clinicalReferenceLink: 'Guide clinique et références académiques',
        noExpression: 'Aucune expression sélectionnée',
        totalScore: 'Score total {{value}}/{{maxValue}}',
        validatedQuestionnaires: 'Informations supplémentaires sur les questionnaires validés',
        wrongExpression: "L'expression n'est pas du bon type",
      },
      pdfCover: {
        reportIsReady: 'Le rapport peut être consulté',
        clickTheButton: 'Cliquez sur le bouton pour consulter le rapport interactif (recommandé)',
        orScroll: "ou faites défiler vers le bas jusqu'à la version PDF",
        buttonText: 'Consulter rapport',
      },
      reportSwitcher: {
        currentReport: 'Rapport actuel terminé le',
        partialReport: 'Rapport partiel mis à jour le',
        mostRecentLabel: '(le plus récent)',
        reportInfo: '{{mostRecent}}| {{index}} sur {{total}}',
      },
      showCalculation: {
        showCalculation: 'Afficher les calculs',
      },
    },
    conditionNotAdministered: 'Non administré',
    conditionNotShown: 'N/A',
    conditionSkipped: 'Ignoré',
    questionNotCompleted: 'Non complété',
    questionNotShown: 'Pas demandé',
  },
  'ui-components': {
    appBar: {
      openUserMenu: 'Ouvrir le menu utilisateur',
      userMenu: 'Menu utilisateur',
    },
    banner: {
      dismiss: 'Fermer la bannière',
    },
    'demographics-bar': {
      demographic: {
        age: 'Âge',
        'date-of-birth': 'Date de naissance',
        eprIdLabel: 'EPR ID',
        ethnicity: 'Origine ethnique',
        gender: 'Genre',
        name: 'Nom',
        notFoundText: 'Pas trouvé',
        sex: 'Sexe',
      },
      'patient-id-mismatch': {
        label: 'Le numéro NHS fourni ne correspond pas à la recherche NHS',
        text: 'IDENTITÉ NON VÉRIFIÉE',
      },
      incompletePlaceholder: 'Incomplet',
    },
    dropdownMenu: {
      noItemsAvailable: 'Aucun élément disponible',
      openMenu: 'Ouvrir le menu',
    },
    genericError: {
      title: 'Désolé, nous rencontrons actuellement un problème technique.',
      subtitle: 'Merci de nous contacter à <linkTag /> si le problème persiste.',
    },
    loggedOut: {
      title: 'Vous êtes déconnecté',
      ssoMessage:
        'La prochaine fois que vous reviendrez, vous serez automatiquement connecté via votre compte professionnel.',
      goToLogin: 'Se connecter',
    },
    patientAppBar: {
      crisisText: 'Aide urgente',
    },
    privacyPolicy: {
      redirecting: 'Redirection vers la Politique de confidentialité...',
    },
    showCalculation: {
      calculation: 'calcul',
    },
    staleBuildError: {
      title: "Cette page n'est plus à jour. Merci de <refreshLink>rafraîchir</refreshLink> pour continuer.",
      subtitle: 'Merci de nous contacter à <linkTag /> si le problème persiste.',
    },
    survey: {
      attachments: {
        maxFilesExceeded: 'Vous pouvez téléverser un maximum de {{max}} fichiers pour cette question.',
        unsafeFile:
          "Ce fichier n'a pas pu être téléversé car il a été identifié comme dangereux. Veuillez choisir un autre fichier.",
        scanUnavailable: "Nous n'avons pas pu vérifier ce fichier pour le moment. Veuillez réessayer.",
        uploadError: "Échec du téléversement. Veuillez réessayer ou contacter l'assistance si le problème persiste.",
      },
      toc: {
        title: 'Table des matières',
      },
    },
    table: {
      filters: {
        filters: 'Filtres',
        moreFilters: 'Plus de filtres',
        removeFilter: 'Supprimer le filtre {{type}}',
        saveFilters: 'Sauvegarder les filtres',
      },
      pagination: {
        label: 'Pagination du tableau',
        nextPage: 'page suivante',
        of: 'sur',
        page: 'Page',
        previousPage: 'page précédente',
      },
    },
    termsAndConditions: {
      redirecting: "Redirection vers les Conditions d'utilisation...",
    },
    urgentHelpButton: {
      buttonText: 'Aide urgente',
      callHelp: 'NHS 111 → choisissez santé mentale (option 2), ou contactez votre médecin généraliste en urgence',
      callSamaritans:
        'Samaritains 116 123 (gratuit, 24h/24, confidentiel) ou envoyez SHOUT au 85258. Moins de 19 ans ? Appelez Childline 0800 1111 (gratuit, privé)',
      callUrgentHelp:
        'Appelez le 999 ou allez aux urgences si vous vous êtes gravement blessé, avez pris une overdose, ou ne pouvez pas rester en sécurité maintenant',
      crisisTeamText:
        "Déjà en soins de santé mentale ? Contactez votre service s'il est ouvert, ou utilisez les services ci-dessus.",
      emergencyTitle: 'URGENCE :',
      goToAE: "Rendez-vous aux urgences les plus proches ou demandez à quelqu'un de vous y emmener",
      talkToSomeoneTitle: "PARLER À QUELQU'UN :",
      title: 'Besoin de soutien maintenant ?',
      urgentHelpTitle: 'AIDE URGENTE :',
    },
  },
};
export default translation;
